import { DefaultLanguage } from 'src/common/types';

type TValueOf<T> = T[keyof T];

type TDictionary = Record<string, string>;

type TLocaleDictionary = {
	[key: string]: TDictionary;
};

const defaultLang = DefaultLanguage.alias;

export function useLocalization(dictionary: TLocaleDictionary): TValueOf<TLocaleDictionary> {
	return dictionary[defaultLang] || dictionary[defaultLang];
}
